const VERSION = '3.12.8';
export default VERSION;
